<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>CONTACTEZ-NOUS</h2>
                    <ul>
                        <li><a routerLink="/">ACCUEIL</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>CONTACTEZ-NOUS</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Contact Information Section -->
<section class="contact-info-section">
    <div class="container">
        <div class="section-header">
            <div class="header-icon">
                <i class="icofont-info-circle"></i>
            </div>
            <h2>Nos Informations de Contact</h2>
            <p>Retrouvez toutes les informations nécessaires pour nous contacter et nous rendre visite.</p>
        </div>
        
        <div class="contact-grid">
            <!-- Carte d'adresse -->
            <div class="contact-card">
                <div class="card-header">
                    <div class="card-icon">
                        <i class="icofont-location-pin"></i>
                    </div>
                    <h3>Notre Adresse</h3>
                </div>
                <div class="card-content">
                    <p class="address-text">{{ appSettingService.value.address }}</p>
                    <p class="city-text">Conakry, Guinée</p>
                    <div class="action-link">
                        <a href="https://maps.google.com" target="_blank" class="map-link">
                            <i class="icofont-map"></i>
                            Voir sur la carte
                        </a>
                    </div>
                </div>
            </div>
            
            <!-- Carte de téléphone -->
            <div class="contact-card" data-aos-delay="200">
                <div class="card-header">
                    <div class="card-icon">
                        <i class="icofont-phone"></i>
                    </div>
                    <h3>Téléphone & Fax</h3>
                </div>
                <div class="card-content">
                    <div class="phone-item">
                        <i class="icofont-phone"></i>
                        <a href="tel:+224{{ appSettingService.value.phone_number1 }}">+224 {{ appSettingService.value.phone_number1 }}</a>
                    </div>
                    <div class="phone-item">
                        <i class="icofont-phone"></i>
                        <a href="tel:+224{{ appSettingService.value.phone_number2 }}">+224 {{ appSettingService.value.phone_number2 }}</a>
                    </div>
                    <div class="action-link">
                        <a href="tel:+224{{ appSettingService.value.phone_number1 }}" class="call-link">
                            <i class="icofont-phone"></i>
                            Appeler maintenant
                        </a>
                    </div>
                </div>
            </div>
            
            <!-- Carte d'email -->
            <div class="contact-card" data-aos-delay="400">
                <div class="card-header">
                    <div class="card-icon">
                        <i class="icofont-email"></i>
                    </div>
                    <h3>Email & Site Web</h3>
                </div>
                <div class="card-content">
                    <div class="email-item">
                        <i class="icofont-email"></i>
                        <a href="mailto:{{ appSettingService.value.email }}">{{ appSettingService.value.email }}</a>
                    </div>
                    <div class="website-item">
                        <i class="icofont-globe"></i>
                        <a href="https://www.bstpgn.com" target="_blank">www.bstpgn.com</a>
                    </div>
                    <div class="action-link">
                        <a href="mailto:{{ appSettingService.value.email }}" class="email-link">
                            <i class="icofont-email"></i>
                            Envoyer un email
                        </a>
                    </div>
                </div>
            </div>
            
            <!-- Heures d'ouverture -->
            <div class="contact-card">
                <div class="card-header">
                    <div class="card-icon">
                        <i class="icofont-clock-time"></i>
                    </div>
                    <h3>Heures d'Ouverture</h3>
                </div>
                <div class="card-content">
                    <div class="schedule-list">
                        <div class="schedule-item">
                            <span class="day">Lundi - Vendredi</span>
                            <span class="time open">8h00 - 17h00</span>
                        </div>
                        <div class="schedule-item">
                            <span class="day">Samedi</span>
                            <span class="time closed">Fermé</span>
                        </div>
                        <div class="schedule-item">
                            <span class="day">Dimanche</span>
                            <span class="time closed">Fermé</span>
                        </div>
                    </div>
                    <div class="status-indicator">
                        <div class="status-dot open"></div>
                        <span>Ouvert aujourd'hui</span>
                    </div>
                </div>
            </div>
            
            <!-- Réseaux sociaux -->
            <div class="contact-card social-card" data-aos-delay="200">
                <div class="card-header">
                    <div class="card-icon">
                        <i class="icofont-share"></i>
                    </div>
                    <h3>Suivez-nous</h3>
                </div>
                <div class="card-content">
                    <p class="social-description">Restez connecté avec nous pour les dernières actualités et opportunités.</p>
                    <div class="social-grid">
                        <a href="{{ appSettingService.value.facebook_url }}" target="_blank" class="social-item facebook">
                            <i class="icofont-facebook"></i>
                            <span>Facebook</span>
                        </a>
                        <a href="{{ appSettingService.value.twiter_url }}" target="_blank" class="social-item twitter">
                            <i class="icofont-twitter"></i>
                            <span>Twitter</span>
                        </a>
                        <a href="{{ appSettingService.value.linkedin_url }}" target="_blank" class="social-item linkedin">
                            <i class="icofont-linkedin"></i>
                            <span>LinkedIn</span>
                        </a>
                        <a href="{{ appSettingService.value.youtube_url }}" target="_blank" class="social-item youtube">
                            <i class="icofont-youtube-play"></i>
                            <span>YouTube</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="map-area pb-0 pt-5">
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3934.320095417701!2d-13.664550610513777!3d9.567650966065095!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xf1cd731e9df587f%3A0xa2f8cb019f00b3c6!2sBourse%20de%20Sous-Traitance%20et%20de%20Partenariats%20-%20Guin%C3%A9e!5e0!3m2!1sen!2sbd!4v1729764681148!5m2!1sen!2sbd" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
</div>